import React, { useEffect, useRef } from "react";
import Hls from "hls.js";

const HlsPlayer = ({ streamingurl }) => {
  const videoRef = useRef(null);

  useEffect(() => {
    let hls;
    const video = videoRef.current;

    if (!video || !streamingurl) return;

    if (Hls.isSupported()) {
      hls = new Hls();
      hls.loadSource(streamingurl);
      hls.attachMedia(video);

      hls.on(Hls.Events.MANIFEST_PARSED, () => {
        video.play().catch(err => {
          console.log("Autoplay prevented:", err);
        });
      });
    } 
    else if (video.canPlayType("application/vnd.apple.mpegurl")) {
      video.src = streamingurl;
      video.addEventListener("loadedmetadata", () => {
        video.play().catch(err => {
          console.log("Autoplay prevented:", err);
        });
      });
    }

    return () => {
      if (hls) hls.destroy();
    };
  }, [streamingurl]);

  return (
    <video
      ref={videoRef}
      controls
      autoPlay
      muted          // ✅ REQUIRED for autoplay
      playsInline    // ✅ Important for mobile
      style={{ width: "100%" }}
    />
  );
};

export default HlsPlayer;